/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-floating-promises */
import {
  CloseOutlined,
  DeleteOutlined,
  SearchOutlined,
  UserAddOutlined,
} from "@ant-design/icons";
import {
  Button,
  Col,
  Divider,
  Form,
  Input,
  Modal,
  Popconfirm,
  Row,
  Space,
  Tag,
} from "antd";
import Table, { type ColumnsType } from "antd/lib/table";
import { type FilterValue } from "antd/lib/table/interface";
import Title from "antd/lib/typography/Title";
import React, { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../hooks/hooks";
import {
  deleteUserAsync,
  getAvailableRolesAsync,
  getAvailableZonesAsync,
  getUsersAsync,
  selectLoading,
  selectModalOpen,
  selectUsersCurrentPage,
  selectUsersList,
  setCurrentPage,
  setManagedUser,
  setModalOpen,
  setZones,
  selectCurrentUser as selectCurrentManagedUser,
} from "../../redux/slices/manageUsers/manageUsersSlice";
import { type UserType } from "../../redux/slices/manageUsers/manageUsersTypes";
import { type PaginationParams } from "../../redux/slices/midservice/midserviceTypes";
import { timestampToReadable } from "../../utils/time";
import AddUserForm from "./AddUserForm";

const ManageUsersPage: React.FC = () => {
  const managedUser = useAppSelector(selectCurrentManagedUser);
  const usersList = useAppSelector(selectUsersList);
  const modalOpen = useAppSelector(selectModalOpen);

  const loading = useAppSelector(selectLoading);
  const dispatch = useAppDispatch();
  const [filter, setFilter] = useState<Record<string, FilterValue | null>>({});
  const [searchString, setSearchString] = useState<string>();
  const [pageSize, setPageSize] = useState(10);
  const page = useAppSelector(selectUsersCurrentPage);

  const [form] = Form.useForm();

  useEffect(() => {
    const paginationParams: PaginationParams = {
      page,
      limit: pageSize,
    };
    dispatch(getUsersAsync(paginationParams));
    dispatch(getAvailableZonesAsync());
    dispatch(getAvailableRolesAsync());
  }, []);

  const columns: ColumnsType<UserType> = [
    {
      title: "Логин",
      dataIndex: "login",
      key: "login",
      render: (text, record, index) => (
        <Space size="middle">
          <Button
            type="link"
            onClick={() => {
              onUserEdit(usersList.content[index]);
            }}
          >
            {text}
          </Button>
        </Space>
      ),
    },
    {
      title: "Имя",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Роль",
      dataIndex: "role",
      key: "role",
      filters: [
        {
          text: "OWNER",
          value: "OWNER",
        },
        {
          text: "ADMIN",
          value: "ADMIN",
        },
        {
          text: "ENGINEER",
          value: "ENGINEER",
        },
        {
          text: "VIEWER",
          value: "VIEWER",
        },
      ],
      filteredValue: filter.role ?? null,
    },
    {
      title: "Дата создания",
      dataIndex: "ts",
      key: "ts",
      render: (text) => timestampToReadable(text),
    },
    {
      title: "Статус",
      dataIndex: "isActive",
      key: "isActive",
      filters: [
        {
          text: "Enabled",
          value: true,
        },
        {
          text: "Diasbled",
          value: false,
        },
      ],
      filteredValue: filter.isActive ?? null,
      render: (value) => {
        if (value != null) return <Tag color="blue">Enabled</Tag>;
        return <Tag>Disabled</Tag>;
      },
    },

    {
      title: "Управление",
      key: "action",
      fixed: "right",
      width: 100,

      render: (_, record) => (
        <>
          <Popconfirm
            okText={"Да"}
            cancelText={"Отменить"}
            title="Удалить пользователя?"
            onConfirm={async () => await dispatch(deleteUserAsync(record.id))}
          >
            <DeleteOutlined style={{ color: "#f5222d" }} />
          </Popconfirm>
        </>
      ),
    },
  ];

  // const onPaginationChange = (newPage: number, newPageSize: number) => {
  //   console.log('pagination', newPage, newPageSize)
  //   setPage(newPage)
  //   setPageSize(newPageSize)
  // }

  const filtersToQueryString = (
    filters: Record<string, FilterValue | null>,
  ): string => {
    let filterString: string = "";
    for (const [key, value] of Object.entries(filters)) {
      if (value == null) {
        continue;
      }
      if (filterString !== "") {
        filterString += "-";
      }

      filterString += `${key}*${String(value)}`;
    }

    return filterString;
  };

  const onTableChange = (
    pagination: any,
    filters: any,
    sorter: any,
    extra: any,
  ): void => {
    console.log("onTableChange", pagination, filters, sorter, extra);

    const paginationParams: PaginationParams = {
      page: pagination.current,
      limit: pagination.pageSize,
      filter: filtersToQueryString(filters),
      search: searchString,
    };
    dispatch(getUsersAsync(paginationParams));

    dispatch(setCurrentPage(pagination.current));
    setPageSize(pagination.pageSize);
    setFilter(filters);
    console.log("filterss", filters);
  };

  const onSearchChange = (value: any): void => {
    console.log("search", value.target.value);
    setSearchString(value.target.value);
    const paginationParams: PaginationParams = {
      page,
      limit: pageSize,
      filter: filtersToQueryString(filter),
      search: value.target.value,
    };
    dispatch(getUsersAsync(paginationParams));
  };

  const dropFilters = (): void => {
    const paginationParams: PaginationParams = {
      page,
      limit: pageSize,
    };
    dispatch(getUsersAsync(paginationParams));

    setFilter({});
    setSearchString("");
  };

  const onUserEdit = (user: UserType | null): void => {
    dispatch(setManagedUser(user));
    dispatch(setModalOpen(true));
    if (user != null) {
      console.log("zones", user, user.zones);
      dispatch(setZones(user.zones));
    } else dispatch(setZones([]));
  };

  return (
    <>
      <Row>
        <Col flex="auto">
          <Title level={3}>Управление пользователями</Title>
        </Col>
        <Col span={6} offset={1} flex="none">
          <Button
            onClick={() => {
              onUserEdit(null);
            }}
            type="primary"
            icon={<UserAddOutlined />}
          >
            Добавить пользователя
          </Button>
        </Col>
      </Row>
      <Divider />
      <Row style={{ marginBottom: "1rem" }}>
        <Col flex="auto">
          <Input
            addonBefore={<SearchOutlined />}
            placeholder="Поиск по всем полям"
            allowClear
            onChange={onSearchChange}
            value={searchString}
          />
        </Col>
        <Col span={6} offset={1} flex="none">
          <Button onClick={dropFilters} icon={<CloseOutlined />}>
            Сбросить фильтры{" "}
          </Button>
        </Col>
      </Row>

      <Modal
        title={
          managedUser?.id != null
            ? `Редактирование пользователя ${managedUser.login}`
            : "Добавление нового пользователя"
        }
        centered
        open={modalOpen}
        onOk={() => {
          form.submit();
        }}
        onCancel={() => dispatch(setModalOpen(false))}
        width={1000}
        confirmLoading={loading}
        okText={managedUser?.id != null ? "Обновить" : "Добавить"}
        cancelText="Отменить"
      >
        <AddUserForm form={form} />
      </Modal>

      <Table
        size="small"
        onChange={onTableChange}
        pagination={{
          // onChange: onPaginationChange,
          showSizeChanger: true,
          pageSize: usersList.pageSize,
          total: usersList.totalRecord,
          current: page,
        }}
        scroll={{ x: true }}
        columns={columns}
        dataSource={usersList.content}
      />
    </>
  );
};

export default ManageUsersPage;
